import { render, staticRenderFns } from "./NewDashboardCustomFab.vue?vue&type=template&id=bad85b42&scoped=true"
import script from "./NewDashboardCustomFab.vue?vue&type=script&lang=js"
export * from "./NewDashboardCustomFab.vue?vue&type=script&lang=js"
import style0 from "./NewDashboardCustomFab.vue?vue&type=style&index=0&id=bad85b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad85b42",
  null
  
)

export default component.exports